export default __webpack_public_path__ + "static/media/saved_en.d5b93784.webp";